export var ASSET_PRELOADER_ERROR = 'You do not have an asset manifest file, either turn PRELOAD_ASSETS off or run npm run postinstall';
export var CHECK_USER_SAVED_TOKEN_ERROR = 'Check user saved token:';
export var CANNOT_OPEN_DATE_PICKER_ERROR = 'Cannot open date picker';
export var GAME_ID_OR_TOKEN_NOT_SET_ERROR = 'gameId or token not set.';
export var ODR_DOWNLOAD_ERROR_MESSAGE = 'An error has occurred while downloading the game.';